import { useFetchJobTasks } from "@labeling-tools/api/lebron/react-query-hooks";
import { getCurrentTaskNumber } from "@labeling-tools/ui-components/src/utils/helpers";
import { useParams } from "react-router-dom";
import { Text } from "@mantine/core";

export const TaskCounter = ({
  taskId,
}: {
  taskId: string | null | undefined;
}) => {
  const { jobId } = useParams<{ jobId: string }>();
  const { data: jobTasks } = useFetchJobTasks(jobId || "");
  const { current, total } = getCurrentTaskNumber(jobTasks, taskId || "");
  if (current === 0 || total === 0 || !taskId) {
    return null;
  }
  return (
    <Text size="sm" className="text-gray-600 absolute top-0 right-0">
      {current} / {total}
    </Text>
  );
};
